import { reduceCollectionHandler } from 'utils/model';
import { FETCH_COUNTRIES } from './actions';

const initialState = { data: [] };

export default function countries(state = initialState, action) {
  const { type } = action;
  switch (type) {
    case FETCH_COUNTRIES:
      return reduceCollectionHandler(state, action);

    default:
      return state;
  }
}
